module.exports = __webpack_public_path__ + "media/lista_zakupow.5ce520b2.mp3";